export default "__VITE_ASSET__DxdrWrw5__"